import { styled } from "styled-components";

export const ListWrapper = styled.div`
  padding-top: ${({ theme }) => theme.spacing[4]};
`;
